<template>
  <!--<CustomerForm />-->
  <CustomerForm @submit="goBack"/>
</template>

<script>

import CustomerForm from "@/components/page-components/Account/Customer/CustomerForm.vue";

export default {
  components: {
    CustomerForm,
  },
  inject:['findInject'],
  methods:{
    goBack:function(){
      setTimeout(this.findInject('goBack'),4000);
    },
  }
}
</script>
